import React, { useRef, useState } from "react";
import { TopButs } from "./TopButs";
import { TabBar } from "./TabBar";
import useNavModel, { RouterParamType } from "@/model/navModel";
import { IYhFormRef } from "@/components/YhFormBox/Types";


export const EnquiryDetails = () => {
    const { getSelectedNavState } = useNavModel(() => []);
    const [detailsInfo] = useState<RouterParamType>(getSelectedNavState() as RouterParamType);
    const formRef = useRef<IYhFormRef>();
    return (
        <>
            {detailsInfo && <>
                <TopButs formRef={formRef} {...detailsInfo} />
                <TabBar formRef={formRef} {...detailsInfo} />
            </>
            }
        </>
    )
}